import types from "../types/types";

const currentPrepayments = (curr) => {
	return (dispatch) => {
		dispatch({
			type: types.SET_CURRENT_PREPAYMENTS,
			payload: curr,
		});
	};
};

export default currentPrepayments;
